import React, { useState } from 'react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'Are these products safe for human consumption?',
      answer:
        'No. All products sold by Australian Peptide Science are strictly for laboratory research purposes only. They are not intended for human consumption, veterinary use, or clinical application. These compounds are not approved for therapeutic use and should only be handled by qualified research personnel.',
    },
    {
      question: 'What is a Certificate of Analysis (COA)?',
      answer:
        'A Certificate of Analysis is an official document from an independent testing laboratory that verifies the purity, composition, and quality of our peptides. Each COA includes detailed test results from HPLC, mass spectrometry, and other analytical methods. We provide COAs for every batch we sell.',
    },
    {
      question: 'How do I verify the authenticity of a COA?',
      answer:
        'Each COA includes a unique QR code and verification key that can be used to confirm authenticity directly with the testing laboratory (such as Janoshik Analytical). Visit the laboratory\'s website and enter the verification code to access the original test results.',
    },
    {
      question: 'What is your purity standard?',
      answer:
        'We maintain a minimum purity standard of ≥98% across all products. Most of our peptides exceed 99% purity. Each product listing displays the specific purity level for that batch.',
    },
    {
      question: 'How should peptides be stored?',
      answer:
        'Lyophilised (freeze-dried) peptides should be stored in a refrigerator (2-8°C) or freezer (-20°C) until reconstitution. Once reconstituted, peptides should be stored according to the specific compound\'s stability requirements, typically refrigerated and used within a specified timeframe.',
    },
    {
      question: 'Do you ship within Australia only?',
      answer:
        'Yes, we currently provide shipping to addresses within Australia only. We use express domestic shipping with tracking. Orders are typically dispatched within 1-2 business days.',
    },
    {
      question: 'What is your shipping policy?',
      answer:
        'We provide fast Australian domestic shipping with tracking included. All shipments are packaged discreetly. Shipping costs are calculated at checkout based on your location and order size.',
    },
    {
      question: 'Do I need a research license to purchase?',
      answer:
        'Customers should ensure compliance with all applicable local regulations regarding the purchase and handling of research chemicals. Australian Peptide Science sells exclusively to research institutions, laboratories, and qualified research personnel.',
    },
    {
      question: 'Can you provide dosage recommendations?',
      answer:
        'No. We do not provide dosage recommendations, administration protocols, or any information related to human or veterinary use. Our products are research chemicals only, and we cannot advise on their application.',
    },
    {
      question: 'What is your return policy?',
      answer:
        'Due to the nature of our products and quality control requirements, we cannot accept returns once a package has been shipped. If you receive a damaged product or have concerns about product quality, please contact us immediately with photos and batch information.',
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="py-24 lg:py-32">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <h1 className="text-4xl sm:text-5xl font-heading font-bold tracking-tighter text-primary-main mb-6" data-testid="faq-heading">
          Frequently Asked Questions
        </h1>
        <p className="text-lg text-text-secondary mb-12">
          Find answers to common questions about our products, quality standards, and policies.
        </p>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white border border-slate-200 rounded-lg overflow-hidden"
              data-testid={`faq-item-${index}`}
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-background-subtle transition-colors"
                data-testid={`faq-question-${index}`}
              >
                <span className="font-heading font-semibold text-primary-main pr-8">{faq.question}</span>
                <span
                  className={`text-accent-main text-2xl transform transition-transform ${
                    openIndex === index ? 'rotate-45' : ''
                  }`}
                >
                  +
                </span>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-5 text-text-secondary leading-relaxed" data-testid={`faq-answer-${index}`}>
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-16 bg-background-subtle border border-slate-200 rounded-lg p-8 text-center">
          <h3 className="text-xl font-heading font-semibold text-primary-main mb-3">
            Still have questions?
          </h3>
          <p className="text-text-secondary mb-6">
            Contact us for research enquiries and institutional purchasing information.
          </p>
          <a href="/contact" className="btn-primary inline-block" data-testid="contact-us-button">
            Contact Us
          </a>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
